import Base from './Base';
import CompanyModel from './Company';
import ImageModel from './Image';

export default class UserModel extends Base  {
	public id: number;
	public full_name:string;
	private _firstname: string;
	private _insertion: string;
	private _lastname: string;
	private _phone1: string;
	private _phone2: string;
	private _email: string;
	public _image: object;
	private _state: number;
	private _company: object;
	private _companies: Array<CompanyModel>;
	
	constructor(data?: object) {
		super(null);

		this.id = 0;
		this.full_name = "";
		this.firstname = "";
		this.insertion = "";
		this.lastname = "";
		this.phone1 = "";
		this.phone2 = "";
		this.email = "";
		this._image = new ImageModel();
		//this.company = new CompanyModel(data);
		
		this.addData(data);
	}

	
	get firstname() {
		return this._firstname;
	}
	set firstname(val) {
		this._firstname = val;
	}

	get insertion() {
		return this._insertion;
	}
	set insertion(val) {
		this._insertion = val;
	}

	get lastname() {
		return this._lastname;
	}
	set lastname(val) {
		this._lastname = val;
	}

	get phone1() {
		return this._phone1;
	}
	set phone1(val) {
		this._phone1 = val;
	}

	get phone2() {
		return this._phone2;
	}
	set phone2(val) {
		this._phone2 = val;
	}

	get email() {
		return this._email;
	}
	set email(val) {
		this._email = val;
	}

	get state() {
		return this._state;
	}
	set state(val) {
		this._state = val;
	}
		
	get company() {
		return this._company;
	}
	set company(value) {
		const companyModel = new CompanyModel(value);
		this._company = companyModel;
	}	

	get companies() {
		return this._companies;
	}
	set companies(value) {
		const companyArray = [];
		let i;
		for(i in value) {
			const companyModel = new CompanyModel(value[i]);
			companyArray.push(companyModel);
		}
		this._companies = companyArray;
	}	

	get image() {
		return this._image;
	}
	set image(value: any) {
		console.log("set image!!!!", value);
		const imageModel = new ImageModel(value);
		this._image = imageModel;
	}
	isProvider() {
		let retVal = false;
		if(this.company && this.company.type == "PROVIDER") {
			retVal = true;
		}	
		return retVal;
	}		
	
	protected serialize() {
		const str = JSON.stringify(this);
		return str;
	}
	
	public createNewInstance() {
		return new UserModel();
	}


	
}